// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#4CAF50',
            light: '#81C784',
            dark: '#388E3C',
        },
        secondary: {
            main: '#f50057',
        },
        background: {
            default: '#ffffff',
        },
    },
    typography: {
        // Main font family for your app
        fontFamily: 'Inter, sans-serif',

        // Additional font families that can be referenced
        filsonFontFamily: '"Filson Soft", sans-serif',
        interFontFamily: 'Inter, sans-serif',
        mavenProFontFamily: 'MavenPro, sans-serif',

        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
    },
    shape: {
        borderRadius: 8,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
                @font-face {
                    font-family: 'Filson Soft';
                    font-style: normal;
                    font-display: swap;
                    font-weight: 400;
                    src: url('/fonts/Filson_Soft_Regular.otf') format('opentype');
                    unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                }
                
                @font-face {
                    font-family: 'Inter';
                    font-style: normal;
                    font-display: swap;
                    font-weight: 400;
                    src: url('/fonts/Inter_18pt-Regular.ttf') format('truetype');
                    unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                }
                
                @font-face {
                    font-family: 'MavenPro';
                    font-style: normal;
                    font-display: swap;
                    font-weight: 400;
                    src: url('/fonts/MavenPro-Regular.ttf') format('truetype');
                    unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
                }
            `,
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        // Other component customizations...
    },
});

export default theme;